// extracted by mini-css-extract-plugin
module.exports = {"grid":"style_grid__3uirJ","column":"style_column__2cIFT","row":"style_row__3Nygj"};